import { Component, OnInit, Inject, ViewChild, Optional, OnDestroy, HostListener, ViewEncapsulation } from '@angular/core';
import { UntypedFormControl, Validators, UntypedFormGroup, UntypedFormBuilder, UntypedFormArray, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatRadioButton } from '@angular/material/radio';
import { MatCheckbox } from '@angular/material/checkbox';

import { CookieService } from 'ngx-cookie-service';
import { LoggingService } from '@EfsServices/logging.service';
import { DataSharingService } from '../shared/services/data-sharing.service';
import { EfsApiService } from '@EfsServices/efs-api.service';
import { environment } from '@efsEnvironments/environment';
import { GenericPopupComponent } from '@EfsReusable/generic-popup/generic-popup.component';
import { ApiErrorHandlingService } from '@EfsServices/api-error-handling.service';
import { SessionTimerService } from '@EfsServices/session-timer.service';
import { PermissionHandlingService } from '@efsShared/services/permission-handling.service';

@Component({
    selector: 'app-single-user-setup-icc',
    templateUrl: './single-user-setup-icc.component.html',
    styleUrls: [
        './styles/styles.scss'
    ],
    standalone: false
})
export class SingleUserSetupICCComponent {
  moduleInfo = {
    moduleName: 'moduleSUSICC',
    moduleVersion: '0.2.0',
  };

  email = new FormControl('', [Validators.required, Validators.email]);
  form: UntypedFormGroup;

  employeeFacilityLocation = [];

  userFormTitle = 'User Results';
  leftPanelTitle = 'Currently do not have access to Single User Setup ICC';

  validInfactUser = false;

  adminId = '';

  creatingNewUser = false;

  popupDialogRef;
  useSpinner = false;

  showUserResults = false;
  newUserEntry = false;
  loadScreen = false;

  employeeInformation;

  infactUserIdInputControl = new UntypedFormControl({ value: '', disabled: false }, [
    Validators.pattern('^[a-zA-Z0-9_]*$'),
    Validators.required,
  ]);
  userControl = new UntypedFormControl({ value: '', disabled: false }, [
    Validators.pattern('^[a-zA-Z0-9]*$'),
    Validators.required,
  ]);
  employeeIdControl = new UntypedFormControl({ value: '', disabled: false }, [
    Validators.pattern('^[0-9]*$'),
  ]);
  employeeIdInputControl = new UntypedFormControl({ value: '', disabled: false }, [
    Validators.pattern('^[0-9]*$'),
    Validators.required,
  ]);
  firstNameControl = new UntypedFormControl({ value: '', disabled: false }, [
    Validators.pattern('^[a-zA-Z0-9\']*$'),
    Validators.required,
  ]);
  lastNameControl = new UntypedFormControl({ value: '', disabled: false }, [
    Validators.pattern('^[a-zA-Z0-9\']*$'),
    Validators.required,
  ]);
  iccUserNameControl = new UntypedFormControl({ value: '', disabled: false }, [
    Validators.pattern('^[a-zA-Z0-9]*$'),
    Validators.required,
  ]);

  accessLevelTemplateControl = new UntypedFormControl('', [
    Validators.required,
  ]);

  get checkboxesFormArray() {
    return this.form.controls.checkBoxes as UntypedFormArray;
  }

  checked = true;
  disabled = false;

  disableSubmitButton = true;
  disableInactivateButton = false;
  verifyInfactUserButtonDisable = false;
  disableAccessLevelTemplate = false;

  multiselect = new FormControl([], [
    Validators.required
  ]);
  selectOptionList: string[] = ['EDH', 'HAR', 'KCW', 'CPL', 'EDG', 'NTLEDH', 'NTLCLF'];
  selectOptionListUAT: string[] = ['HAR'];
  selectOptions: SelectOption[] = [
    { value: 'steak-0', viewValue: 'Client Services' },
    { value: 'pizza-1', viewValue: 'Pizza' },
    { value: 'tacos-2', viewValue: 'Tacos' }
  ];

  // submission status booleans
  showSubmissionStatus = false;
  showInactivateUserStatuses = false;
  showCreateUserStatuses = false;
  showUpdateStatuses = false;

  // showSubStatusEDH = false;
  // showSubStatusHAR = false;
  // showSubStatusKCW = false;
  // showSubStatusCPL = false;
  // showSubStatusEDGE = false;
  // showSubStatusNTLEDH = false;
  // showSubStatusNTLCLF = false;

  showSuccessStatusEDH = '';
  showSuccessStatusHAR = '';
  showSuccessStatusKCW = '';
  showSuccessStatusCPL = '';
  showSuccessStatusEDGE = '';
  showSuccessStatusNTLEDH = '';
  showSuccessStatusNTLCLF = '';

  showUpdateSuccessStatusEDH = '';
  showUpdateSuccessStatusHAR = '';
  showUpdateSuccessStatusKCW = '';
  showUpdateSuccessStatusCPL = '';
  showUpdateSuccessStatusEDGE = '';
  showUpdateSuccessStatusNTLEDH = '';
  showUpdateSuccessStatusNTLCLF = '';

  showInactivateSuccessStatusEDH = '';
  showInactivateSuccessStatusHAR = '';
  showInactivateSuccessStatusKCW = '';
  showInactivateSuccessStatusCPL = '';
  showInactivateSuccessStatusEDGE = '';
  showInactivateSuccessStatusNTLEDH = '';
  showInactivateSuccessStatusNTLCLF = '';

  // list item security templates for each facility
  securityTemplateEDH = [];
  securityTemplateHAR = [];
  securityTemplateKCW = [];
  securityTemplateCPL = [];
  securityTemplateEDGE = [];
  securityTemplateNTLEDH = [];
  securityTemplateNTLCLF = [];
  securityTemplateALL = [];
  securityTemplateFiltered = [];
  finalSecurityTemplatesFiltered = [];
  finalFinalSecurityTemplatesFiltered = [];

  // user by facility
  userInfoEDH;
  userInfoHAR;
  userInfoKCW;
  userInfoCPL;
  userInfoEDGE;
  userInfoNTLEDH;
  userInfoNTLCLF;
  // a single user to check against
  userInfoAny;

  // user body for api
  formInformation;

  // location URLS for LFS
  lfsLocationUrls = [
    'EDH', 'HAR', 'KCW', 'CPL', 'EDG', 'NTLEDH', 'NTLCLF'
  ]

  // used for tracking the facilities selected by the user, it should be checked against the employeeFacilityLocation list
  // this way, you do a create new user in new selected facilities, and you do an update template user on already existing facilties.
  userSelectedFacilities = [];

  // variables used in role admin
  userList = [];
  disableInactivate = true;
  dropdownList = [];
  // end of variables

  constructor(
    private dataSharingService: DataSharingService,
    private cookieService: CookieService,
    private router: Router,
    @Optional() @Inject(MAT_DIALOG_DATA) public data,
    private efsApiService: EfsApiService,
    public dialog: MatDialog,
    public loggingService: LoggingService,
    private apiErrorHandlingService: ApiErrorHandlingService,
    private sessionTimerService: SessionTimerService,
    private formBuilder: UntypedFormBuilder,
    public permissionHandlingService: PermissionHandlingService,
  ) {
    this.form = this.formBuilder.group({
      checkBoxes: new UntypedFormArray([], [
        // Validators.required
      ])
    });
  }

  ngOnInit(): void {
    this.dataSharingService.shareData(this.moduleInfo); // share name and version of module; update here
    this.loggingService.logInfo('In single user setup ICC page');

    // toggle the submit button in the new user/modify user panel by checking if all input fields are OK
    this.checkFormStatus();

    // check if the env is UAT, change the facility dropdown list
    if (environment.envName === 'UAT') {
      this.selectOptionList = this.selectOptionListUAT;
    }

    // set the lfs token for calling LFS API
    this.efsApiService.getLfsToken().subscribe((data: any) => {
      const lfsToken: string = data;
      console.log(lfsToken);
      sessionStorage.setItem('LFSToken', lfsToken);

      // check user access then grant it
      this.verifyInfactUserButton();

      // get the LFS security template values for infact
      this.getSecurityTemplates();

    }, error => {
      this.apiErrorHandlingService.errorStatusHandler(error);
    });

    // typeahead search for user
    this.userControl.valueChanges.subscribe((input) => {
      this.clearFields();

      const filteredUserList = [];
      for (const item of this.userList) { // match and return look ahead
        const userComboString: string =
          item.firstNm.toUpperCase() + item.lastNm.toUpperCase() + item.employeeId + item.ccUserNm.toUpperCase();
        console.log(userComboString);
        // input.toUpperCase() + item.employeeId.toUpperCase().slice(input.length) === item.employeeId.toUpperCase()
        if (userComboString.match(input.toUpperCase())) {
          filteredUserList.push(item);
        }
      }
      console.log(JSON.stringify(filteredUserList));
      this.dropdownList = filteredUserList;
      this.disableInactivate = true;
    });


    // session timer startup for detecting session
    this.sessionTimer();
  }

  // session timer method for tracking session using mouse movement
  @HostListener('mousemove')
  sessionTimer() {
    this.sessionTimerService.checkSessionStatus();
  }
  // stop session timers once the modal is removed
  ngOnDestroy(): void {
    this.sessionTimerService.stopTimers();
  }

  getErrorMessage() {
    return this.email.hasError('required') ? 'You must enter a value' :
      this.email.hasError('email') ? 'Not a valid email' :
        '';
  }

  // services

  getEDHUsersByAssociateId(employeeId, checkUserAccess?) {

    this.efsApiService.getInfactUsersbyAssociateId(employeeId, 'EDH').subscribe((data: any) => {
      console.log(JSON.stringify(data));
      let employeeFound = [];
      employeeFound = data;
      this.userInfoEDH = employeeFound;

      // set employee info
      try {
        // only grab facility if an employee was found
        // track all the facilities this employee shows up in
        if (employeeFound.length > 0) {
          this.employeeFacilityLocation.push('EDH');
          this.employeeInformation = employeeFound[0];
          this.userInfoAny = employeeFound;
          console.log(this.userInfoAny);

          if (checkUserAccess) {
            // this is for verifying the user using this screen exists in infact
            this.validInfactUser = true;
            this.leftPanelTitle = 'User Search';
            this.verifyInfactUserButtonDisable = false;
            sessionStorage.setItem('ICCUserId', this.employeeInformation.userId);
          }

        }
        this.firstNameControl.setValue(this.employeeInformation.firstName);
        this.lastNameControl.setValue(this.employeeInformation.lastName);
        this.email.setValue(this.employeeInformation.email);
        this.iccUserNameControl.setValue(this.employeeInformation.userId);
        this.employeeIdInputControl.setValue(this.employeeInformation.associateId);
        // this.useSpinner = false;
      } catch {
        console.log('no employee found');
      }

      this.setFacilityDropdown();
      console.log(this.employeeFacilityLocation);
      this.getHARUsersByAssociateId(employeeId, checkUserAccess);

    }, error => {
      this.apiErrorHandlingService.errorStatusHandler(error);
      this.useSpinner = false;
      this.cancelButton();
    });

  }

  getHARUsersByAssociateId(employeeId, checkUserAccess?) {

    this.efsApiService.getInfactUsersbyAssociateId(employeeId, 'HAR').subscribe((data: any) => {
      console.log(JSON.stringify(data));
      let employeeFound = [];
      employeeFound = data;
      this.userInfoHAR = employeeFound;

      // set employee info
      try {
        // only grab facility if an employee was found
        // track all the facilities this employee shows up in
        if (employeeFound.length > 0) {
          this.employeeFacilityLocation.push('HAR');
          this.employeeInformation = employeeFound[0];
          this.userInfoAny = employeeFound;

          if (checkUserAccess) {
            // this is for verifying the user using this screen exists in infact
            this.validInfactUser = true;
            this.leftPanelTitle = 'User Search';
            this.verifyInfactUserButtonDisable = false;
            sessionStorage.setItem('ICCUserId', this.employeeInformation.userId);
          }
        }
        this.firstNameControl.setValue(this.employeeInformation.firstName);
        this.lastNameControl.setValue(this.employeeInformation.lastName);
        this.email.setValue(this.employeeInformation.email);
        this.iccUserNameControl.setValue(this.employeeInformation.userId);
        this.employeeIdInputControl.setValue(this.employeeInformation.associateId);
        // this.useSpinner = false;
      } catch {
        console.log('no employee found');
      }

      console.log(this.employeeFacilityLocation);
      this.getKCWUsersByAssociateId(employeeId, checkUserAccess);

    }, error => {
      this.apiErrorHandlingService.errorStatusHandler(error);
      this.useSpinner = false;
      this.cancelButton();
    });

  }

  getKCWUsersByAssociateId(employeeId, checkUserAccess?) {

    this.efsApiService.getInfactUsersbyAssociateId(employeeId, 'KCW').subscribe((data: any) => {
      console.log(JSON.stringify(data));
      let employeeFound = [];
      employeeFound = data;
      this.userInfoKCW = employeeFound;


      // set employee info
      try {
        // only grab facility if an employee was found
        // track all the facilities this employee shows up in
        if (employeeFound.length > 0) {
          this.employeeFacilityLocation.push('KCW');
          this.employeeInformation = employeeFound[0];
          this.userInfoAny = employeeFound;

          if (checkUserAccess) {
            // this is for verifying the user using this screen exists in infact
            this.validInfactUser = true;
            this.leftPanelTitle = 'User Search';
            this.verifyInfactUserButtonDisable = false;
            sessionStorage.setItem('ICCUserId', this.employeeInformation.userId);
          }
        }
        this.firstNameControl.setValue(this.employeeInformation.firstName);
        this.lastNameControl.setValue(this.employeeInformation.lastName);
        this.email.setValue(this.employeeInformation.email);
        this.iccUserNameControl.setValue(this.employeeInformation.userId);
        this.employeeIdInputControl.setValue(this.employeeInformation.associateId);
        // this.useSpinner = false;
      } catch {
        console.log('no employee found');
      }

      console.log(this.employeeFacilityLocation);
      this.getCPLUsersByAssociateId(employeeId, checkUserAccess);

    }, error => {
      this.apiErrorHandlingService.errorStatusHandler(error);
      this.useSpinner = false;
      this.cancelButton();
    });

  }

  getCPLUsersByAssociateId(employeeId, checkUserAccess?) {

    this.efsApiService.getInfactUsersbyAssociateId(employeeId, 'CPL').subscribe((data: any) => {
      console.log(JSON.stringify(data));
      let employeeFound = [];
      employeeFound = data;
      this.userInfoCPL = employeeFound;


      // set employee info
      try {
        // only grab facility if an employee was found
        // track all the facilities this employee shows up in
        if (employeeFound.length > 0) {
          this.employeeFacilityLocation.push('CPL');
          this.employeeInformation = employeeFound[0];
          this.userInfoAny = employeeFound;

          if (checkUserAccess) {
            // this is for verifying the user using this screen exists in infact
            this.validInfactUser = true;
            this.leftPanelTitle = 'User Search';
            this.verifyInfactUserButtonDisable = false;
            sessionStorage.setItem('ICCUserId', this.employeeInformation.userId);
          }
        }
        this.firstNameControl.setValue(this.employeeInformation.firstName);
        this.lastNameControl.setValue(this.employeeInformation.lastName);
        this.email.setValue(this.employeeInformation.email);
        this.iccUserNameControl.setValue(this.employeeInformation.userId);
        this.employeeIdInputControl.setValue(this.employeeInformation.associateId);
        // this.useSpinner = false;
      } catch {
        console.log('no employee found');
      }

      console.log(this.employeeFacilityLocation);
      this.getEDGEUsersByAssociateId(employeeId, checkUserAccess);

    }, error => {
      this.apiErrorHandlingService.errorStatusHandler(error);
      this.useSpinner = false;
      this.cancelButton();
    });

  }

  getEDGEUsersByAssociateId(employeeId, checkUserAccess?) {

    this.efsApiService.getInfactUsersbyAssociateId(employeeId, 'EDGE').subscribe((data: any) => {
      console.log(JSON.stringify(data));
      let employeeFound = [];
      employeeFound = data;
      this.userInfoEDGE = employeeFound;


      // set employee info
      try {
        // only grab facility if an employee was found
        // track all the facilities this employee shows up in
        if (employeeFound.length > 0) {
          this.employeeFacilityLocation.push('EDG');
          this.employeeInformation = employeeFound[0];
          this.userInfoAny = employeeFound;

          if (checkUserAccess) {
            // this is for verifying the user using this screen exists in infact
            this.validInfactUser = true;
            this.leftPanelTitle = 'User Search';
            this.verifyInfactUserButtonDisable = false;
            sessionStorage.setItem('ICCUserId', this.employeeInformation.userId);
          }
        }
        this.firstNameControl.setValue(this.employeeInformation.firstName);
        this.lastNameControl.setValue(this.employeeInformation.lastName);
        this.email.setValue(this.employeeInformation.email);
        this.iccUserNameControl.setValue(this.employeeInformation.userId);
        this.employeeIdInputControl.setValue(this.employeeInformation.associateId);
        // this.useSpinner = false;
      } catch {
        console.log('no employee found');
      }

      console.log(this.employeeFacilityLocation);
      this.getNTLEDHUsersByAssociateId(employeeId, checkUserAccess);

    }, error => {
      this.apiErrorHandlingService.errorStatusHandler(error);
      this.useSpinner = false;
      this.cancelButton();
    });

  }

  getNTLEDHUsersByAssociateId(employeeId, checkUserAccess?) {

    this.efsApiService.getInfactUsersbyAssociateId(employeeId, 'NTLEDH').subscribe((data: any) => {
      console.log(JSON.stringify(data));
      let employeeFound = [];
      employeeFound = data;
      this.userInfoNTLEDH = employeeFound;


      // set employee info
      try {
        // only grab facility if an employee was found
        // track all the facilities this employee shows up in
        if (employeeFound.length > 0) {
          this.employeeFacilityLocation.push('NTLEDH');
          this.employeeInformation = employeeFound[0];
          this.userInfoAny = employeeFound;

          if (checkUserAccess) {
            // this is for verifying the user using this screen exists in infact
            this.validInfactUser = true;
            this.leftPanelTitle = 'User Search';
            this.verifyInfactUserButtonDisable = false;
            sessionStorage.setItem('ICCUserId', this.employeeInformation.userId);
          }
        }
        this.firstNameControl.setValue(this.employeeInformation.firstName);
        this.lastNameControl.setValue(this.employeeInformation.lastName);
        this.email.setValue(this.employeeInformation.email);
        this.iccUserNameControl.setValue(this.employeeInformation.userId);
        this.employeeIdInputControl.setValue(this.employeeInformation.associateId);
        // this.useSpinner = false;
      } catch {
        console.log('no employee found');
      }

      console.log(this.employeeFacilityLocation);
      this.getNTLCLFUsersByAssociateId(employeeId, checkUserAccess);

    }, error => {
      this.apiErrorHandlingService.errorStatusHandler(error);
      this.useSpinner = false;
      this.cancelButton();
    });

  }

  getNTLCLFUsersByAssociateId(employeeId, checkUserAccess?) {

    this.efsApiService.getInfactUsersbyAssociateId(employeeId, 'NTLCLF').subscribe((data: any) => {
      console.log(JSON.stringify(data));
      let employeeFound = [];
      employeeFound = data;
      this.userInfoNTLCLF = employeeFound;


      // set employee info
      try {
        // only grab facility if an employee was found
        // track all the facilities this employee shows up in
        if (employeeFound.length > 0) {
          this.employeeFacilityLocation.push('NTLCLF');
          this.employeeInformation = employeeFound[0];
          this.userInfoAny = employeeFound;

          if (checkUserAccess) {
            // this is for verifying the user using this screen exists in infact
            this.validInfactUser = true;
            this.leftPanelTitle = 'User Search';
            this.verifyInfactUserButtonDisable = false;
            sessionStorage.setItem('ICCUserId', this.employeeInformation.userId);
          }
        }
        this.firstNameControl.setValue(this.employeeInformation.firstName);
        this.lastNameControl.setValue(this.employeeInformation.lastName);
        this.email.setValue(this.employeeInformation.email);
        this.iccUserNameControl.setValue(this.employeeInformation.userId);
        this.employeeIdInputControl.setValue(this.employeeInformation.associateId);
        // this.useSpinner = false;
      } catch {
        console.log('no employee found');
        // final search, if not user found do a new user page
        try {
          if (Object.keys(this.userInfoAny).length === 0) {
            if (!checkUserAccess) {
              this.newUserButton();
            }
          }
        } catch {
          if (!checkUserAccess) {
            this.newUserButton();
          }
        }
      }

      this.useSpinner = false;
      this.setSecurityTemplateDropdown();
      console.log(this.employeeFacilityLocation);

    }, error => {
      this.apiErrorHandlingService.errorStatusHandler(error);
      // final search, if not user found do a new user page
      console.log(JSON.stringify(this.userInfoAny));
      try {
        if (Object.keys(this.userInfoAny).length === 0) {
          if (!checkUserAccess) {
            this.newUserButton();
          }
        }
      } catch {
        if (!checkUserAccess) {
          this.newUserButton();
        }
      }
      this.useSpinner = false;
    });

  }

  getLfsUserByEmployeeId(employeeId) {
    this.employeeFacilityLocation = [];

    this.getEDHUsersByAssociateId(employeeId);
  }

  // code for checking for valid infact user ID

  getEDHUsersByUserId(employeeId) {

    this.efsApiService.getInfactUsersbyId(employeeId, 'EDH').subscribe((data: any) => {
      console.log(JSON.stringify(data));
      let employeeFound = [];
      employeeFound = data;

      // set employee info
      try {
        // only grab facility if an employee was found
        // track all the facilities this employee shows up in
        console.log(employeeFound.length);
        if (employeeFound.length > 0) {
          this.validInfactUser = true;
          this.leftPanelTitle = 'User Search';
          this.verifyInfactUserButtonDisable = false;
          return;
        } else {
          console.log('no employee found');
          this.getHARUsersByUserId(employeeId);
        }
      } catch {
        console.log('no employee found');
        this.getHARUsersByUserId(employeeId);
      }

    }, error => {
      this.apiErrorHandlingService.errorStatusHandler(error);
      this.useSpinner = false;
      this.verifyInfactUserButtonDisable = false;
    });

  }

  getHARUsersByUserId(employeeId) {

    this.efsApiService.getInfactUsersbyId(employeeId, 'HAR').subscribe((data: any) => {
      console.log(JSON.stringify(data));
      let employeeFound = [];
      employeeFound = data;

      // set employee info
      try {
        // only grab facility if an employee was found
        // track all the facilities this employee shows up in
        if (employeeFound.length > 0) {
          this.validInfactUser = true;
          this.leftPanelTitle = 'User Search';
          this.verifyInfactUserButtonDisable = false;
          return;
        } else {
          console.log('no employee found');
          this.getKCWUsersByUserId(employeeId);
        }
      } catch {
        console.log('no employee found');
        this.getKCWUsersByUserId(employeeId);
      }

    }, error => {
      this.apiErrorHandlingService.errorStatusHandler(error);
      this.useSpinner = false;
      this.verifyInfactUserButtonDisable = false;
    });

  }

  getKCWUsersByUserId(employeeId) {

    this.efsApiService.getInfactUsersbyId(employeeId, 'KCW').subscribe((data: any) => {
      console.log(JSON.stringify(data));
      let employeeFound = [];
      employeeFound = data;


      // set employee info
      try {
        // only grab facility if an employee was found
        // track all the facilities this employee shows up in
        if (employeeFound.length > 0) {
          this.validInfactUser = true;
          this.leftPanelTitle = 'User Search';
          this.verifyInfactUserButtonDisable = false;
          return;
        } else {
          console.log('no employee found');
          this.getCPLUsersByUserId(employeeId);
        }
      } catch {
        console.log('no employee found');
        this.getCPLUsersByUserId(employeeId);
      }

    }, error => {
      this.apiErrorHandlingService.errorStatusHandler(error);
      this.useSpinner = false;
      this.verifyInfactUserButtonDisable = false;
    });

  }

  getCPLUsersByUserId(employeeId) {

    this.efsApiService.getInfactUsersbyId(employeeId, 'CPL').subscribe((data: any) => {
      console.log(JSON.stringify(data));
      let employeeFound = [];
      employeeFound = data;


      // set employee info
      try {
        // only grab facility if an employee was found
        // track all the facilities this employee shows up in
        if (employeeFound.length > 0) {
          this.validInfactUser = true;
          this.leftPanelTitle = 'User Search';
          this.verifyInfactUserButtonDisable = false;
          return;
        } else {
          console.log('no employee found');
          this.getEDGEUsersByUserId(employeeId);
        }
      } catch {
        console.log('no employee found');
        this.getEDGEUsersByUserId(employeeId);
      }

    }, error => {
      this.apiErrorHandlingService.errorStatusHandler(error);
      this.useSpinner = false;
      this.verifyInfactUserButtonDisable = false;
    });

  }

  getEDGEUsersByUserId(employeeId) {

    this.efsApiService.getInfactUsersbyId(employeeId, 'EDGE').subscribe((data: any) => {
      console.log(JSON.stringify(data));
      let employeeFound = [];
      employeeFound = data;


      // set employee info
      try {
        // only grab facility if an employee was found
        // track all the facilities this employee shows up in
        if (employeeFound.length > 0) {
          this.validInfactUser = true;
          this.leftPanelTitle = 'User Search';
          this.verifyInfactUserButtonDisable = false;
          return;
        } else {
          console.log('no employee found');
          this.getNTLEDHUsersByUserId(employeeId);
        }
      } catch {
        console.log('no employee found');
        this.getNTLEDHUsersByUserId(employeeId);
      }

    }, error => {
      this.apiErrorHandlingService.errorStatusHandler(error);
      this.useSpinner = false;
      this.verifyInfactUserButtonDisable = false;
    });

  }

  getNTLEDHUsersByUserId(employeeId) {

    this.efsApiService.getInfactUsersbyId(employeeId, 'NTLEDH').subscribe((data: any) => {
      console.log(JSON.stringify(data));
      let employeeFound = [];
      employeeFound = data;


      // set employee info
      try {
        // only grab facility if an employee was found
        // track all the facilities this employee shows up in
        if (employeeFound.length > 0) {
          this.validInfactUser = true;
          this.leftPanelTitle = 'User Search';
          this.verifyInfactUserButtonDisable = false;
          return;
        } else {
          console.log('no employee found');
          this.getNTLCLFUsersByUserId(employeeId);
        }
      } catch {
        console.log('no employee found');
        this.getNTLCLFUsersByUserId(employeeId);
      }

    }, error => {
      this.apiErrorHandlingService.errorStatusHandler(error);
      this.useSpinner = false;
      this.verifyInfactUserButtonDisable = false;
    });

  }

  getNTLCLFUsersByUserId(employeeId) {

    this.efsApiService.getInfactUsersbyId(employeeId, 'NTLCLF').subscribe((data: any) => {
      console.log(JSON.stringify(data));
      let employeeFound = [];
      employeeFound = data;


      // set employee info
      try {
        // only grab facility if an employee was found
        // track all the facilities this employee shows up in
        if (employeeFound.length > 0) {
          this.validInfactUser = true;
          this.leftPanelTitle = 'User Search';
          this.verifyInfactUserButtonDisable = false;
          return;
        } else {
          console.log('no employee found');
          this.popupWarning(false, 'No Valid Infact User Found');
          this.verifyInfactUserButtonDisable = false;
        }
      } catch {
        console.log('no employee found');
        this.popupWarning(false, 'No Valid Infact User Found');
        this.verifyInfactUserButtonDisable = false;
      }

    }, error => {
      this.apiErrorHandlingService.errorStatusHandler(error);
      this.useSpinner = false;
      this.verifyInfactUserButtonDisable = false;
      console.log('no employee found');
      this.popupWarning(false, 'No Valid Infact User Found');
      this.verifyInfactUserButtonDisable = false;
    });

  }

  getLfsUserByInfactUserId(employeeId) {
    this.employeeFacilityLocation = [];

    this.getEDHUsersByAssociateId(employeeId, true);
  }

  // end of code for checking valid infact user ID

  // cycle through every facility and get all security templates
  getEDHSecurityTemplates() {
    this.efsApiService.getSecurityTemplates('EDH').subscribe((data: any) => {
      console.log(JSON.stringify(data));
      this.securityTemplateEDH = data;
      // gather all security templates in one place
      for (const item of data) {
        try {
          let exists = this.securityTemplateALL.find(x => x.securityTemplateId === item.securityTemplateId);
          console.log('exists? ' + JSON.stringify(exists));
          if (exists.securityTemplateId === item.securityTemplateId) {
            // do nothing
          } else {
            this.securityTemplateALL.push(item);
          }
        } catch {
          this.securityTemplateALL.push(item);
        }
      }
      console.log(this.securityTemplateALL);
      this.getHARSecurityTemplates();
    }, error => {
      this.apiErrorHandlingService.errorStatusHandler(error);
      this.getHARSecurityTemplates();
    });
  }

  getHARSecurityTemplates() {
    this.efsApiService.getSecurityTemplates('HAR').subscribe((data: any) => {
      console.log(JSON.stringify(data));
      this.securityTemplateHAR = data;
      // gather all security templates in one place
      for (const item of data) {
        try {
          let exists = this.securityTemplateALL.find(x => x.securityTemplateId === item.securityTemplateId);
          console.log('exists? ' + JSON.stringify(exists));
          if (exists.securityTemplateId === item.securityTemplateId) {
            // do nothing
          } else {
            this.securityTemplateALL.push(item);
          }
        } catch {
          this.securityTemplateALL.push(item);
        }
      }
      console.log(this.securityTemplateALL);
      this.getKCWSecurityTemplates();
    }, error => {
      this.apiErrorHandlingService.errorStatusHandler(error);
      this.getKCWSecurityTemplates();
    });

  }

  getKCWSecurityTemplates() {
    this.efsApiService.getSecurityTemplates('KCW').subscribe((data: any) => {
      console.log(JSON.stringify(data));
      this.securityTemplateKCW = data;
      // gather all security templates in one place
      for (const item of data) {
        try {
          let exists = this.securityTemplateALL.find(x => x.securityTemplateId === item.securityTemplateId);
          console.log('exists? ' + JSON.stringify(exists));
          if (exists.securityTemplateId === item.securityTemplateId) {
            // do nothing
          } else {
            this.securityTemplateALL.push(item);
          }
        } catch {
          this.securityTemplateALL.push(item);
        }
      }
      console.log(this.securityTemplateALL);
      this.getCPLSecurityTemplates();
    }, error => {
      this.apiErrorHandlingService.errorStatusHandler(error);
      this.getCPLSecurityTemplates();
    });
  }

  getCPLSecurityTemplates() {
    this.efsApiService.getSecurityTemplates('CPL').subscribe((data: any) => {
      console.log(JSON.stringify(data));
      this.securityTemplateCPL = data;
      // gather all security templates in one place
      for (const item of data) {
        try {
          let exists = this.securityTemplateALL.find(x => x.securityTemplateId === item.securityTemplateId);
          console.log('exists? ' + JSON.stringify(exists));
          if (exists.securityTemplateId === item.securityTemplateId) {
            // do nothing
          } else {
            this.securityTemplateALL.push(item);
          }
        } catch {
          this.securityTemplateALL.push(item);
        }
      }
      console.log(this.securityTemplateALL);
      this.getEDGESecurityTemplates();
    }, error => {
      this.apiErrorHandlingService.errorStatusHandler(error);
      this.getEDGESecurityTemplates();
    });
  }

  getEDGESecurityTemplates() {
    this.efsApiService.getSecurityTemplates('EDGE').subscribe((data: any) => {
      console.log(JSON.stringify(data));
      this.securityTemplateEDGE = data;
      // gather all security templates in one place
      for (const item of data) {
        try {
          let exists = this.securityTemplateALL.find(x => x.securityTemplateId === item.securityTemplateId);
          console.log('exists? ' + JSON.stringify(exists));
          if (exists.securityTemplateId === item.securityTemplateId) {
            // do nothing
          } else {
            this.securityTemplateALL.push(item);
          }
        } catch {
          this.securityTemplateALL.push(item);
        }
      }
      console.log(this.securityTemplateALL);
      this.getNTLEDHSecurityTemplates();
    }, error => {
      this.apiErrorHandlingService.errorStatusHandler(error);
      this.getNTLEDHSecurityTemplates();
    });

  }

  getNTLEDHSecurityTemplates() {
    this.efsApiService.getSecurityTemplates('NTLEDH').subscribe((data: any) => {
      console.log(JSON.stringify(data));
      this.securityTemplateNTLEDH = data;
      // gather all security templates in one place
      for (const item of data) {
        try {
          let exists = this.securityTemplateALL.find(x => x.securityTemplateId === item.securityTemplateId);
          console.log('exists? ' + JSON.stringify(exists));
          if (exists.securityTemplateId === item.securityTemplateId) {
            // do nothing
          } else {
            this.securityTemplateALL.push(item);
          }
        } catch {
          this.securityTemplateALL.push(item);
        }
      }
      console.log(this.securityTemplateALL);
      this.getNTLCLFSecurityTemplates();
    }, error => {
      this.apiErrorHandlingService.errorStatusHandler(error);
      this.getNTLCLFSecurityTemplates();
    });
  }

  getNTLCLFSecurityTemplates() {
    this.efsApiService.getSecurityTemplates('NTLCLF').subscribe((data: any) => {
      console.log(JSON.stringify(data));
      this.securityTemplateNTLCLF = data;
      // gather all security templates in one place
      for (const item of data) {
        try {
          let exists = this.securityTemplateALL.find(x => x.securityTemplateId === item.securityTemplateId);
          console.log('exists? ' + JSON.stringify(exists));
          if (exists.securityTemplateId === item.securityTemplateId) {
            // do nothing
          } else {
            this.securityTemplateALL.push(item);
          }
        } catch {
          this.securityTemplateALL.push(item);
        }
      }
      console.log(this.securityTemplateALL);

    }, error => {
      this.apiErrorHandlingService.errorStatusHandler(error);
    });

  }

  getSecurityTemplates() {
    this.getEDHSecurityTemplates();
  }

  // end of services

  /**
   * set the facility dropdown based on the facilities the user was found in
   */
  setFacilityDropdown() {
    for (const item of this.employeeFacilityLocation) {
      console.log(item);

    }
    this.multiselect.setValue(this.employeeFacilityLocation);
    this.setSecurityTemplateDropdown();

  }

  // button functions
  searchButton() {
    this.userFormTitle = 'User Results';
    this.resetSubmissionStatuses();
    this.clearFields(true);
    // disable un-editable fields
    this.firstNameControl.disable();
    this.lastNameControl.disable();
    this.employeeIdInputControl.disable();
    this.iccUserNameControl.disable();
    this.email.disable();
    // enable editable fields if they had been previously disabled
    this.multiselect.enable();
    this.accessLevelTemplateControl.enable();
    this.creatingNewUser = false;
    console.log('search pressed');
    this.useSpinner = true;
    // TODO do not allow null values/invalid values
    if (this.employeeIdControl.value === '' || !this.employeeIdControl.value) {
      console.log('employee ID is not entered');
      this.useSpinner = false;
      return;
    }

    this.getLfsUserByEmployeeId(this.employeeIdControl.value);

    this.showUserResults = true;

  }

  newUserButton() {
    this.userFormTitle = 'Submit New User';
    // enable all editable fields
    this.firstNameControl.enable();
    this.lastNameControl.enable();
    this.employeeIdInputControl.enable();
    this.iccUserNameControl.enable();
    this.email.enable();
    this.multiselect.enable();
    this.accessLevelTemplateControl.enable();
    console.log('search pressed');
    this.creatingNewUser = true;
    this.clearFields();

    this.showUserResults = true;
    this.newUserEntry = true;

  }

  // ask user if they want to inactive in popup, then inactivate if yes else no
  inactivateButton() {
    console.log('inactivate pressed');
    // disable all buttons
    this.disableSubmitButton = true;
    this.disableInactivateButton = true;
    this.popupWarning(true, 'Are you sure you want to Inactivate this user?');
    this.popupDialogRef.afterClosed().subscribe(result => {
      if (result) {
        console.log('user clicked yes');
        this.showSubmissionStatus = true;
        this.showInactivateUserStatuses = true;
        // disable all fields
        this.firstNameControl.disable();
        this.lastNameControl.disable();
        this.employeeIdInputControl.disable();
        this.iccUserNameControl.disable();
        this.email.disable();
        this.accessLevelTemplateControl.disable();
        this.multiselect.disable();

        // apply the security template to the user for the selected facilities
        console.log(this.multiselect.value);
        let userSelectedFacilities = [];
        try {
          if (this.multiselect.value.length > 0) {
            for (const item of this.multiselect.value) {
              userSelectedFacilities.push(item);
            }
          }
        } catch {
          console.log('no facilities selected');
          return;
        }
        // create a list of facilities where the user already exists in, but has been selected. this is for simple update and no create user
        let updateUserInFacility = [];
        updateUserInFacility = userSelectedFacilities.filter(x => this.employeeFacilityLocation.includes(x));

        for (const item of updateUserInFacility) {
          console.log(JSON.stringify(item));
          if (item === 'EDH') {
            this.inactivateUserEDH();
          } else if (item === 'HAR') {
            this.inactivateUserHAR();
          } else if (item === 'KCW') {
            this.inactivateUserKCW();
          } else if (item === 'CPL') {
            this.inactivateUserCPL();
          } else if (item === 'EDG') {
            this.inactivateUserEDGE();
          } else if (item === 'NTLEDH') {
            this.inactivateUserNTLEDH();
          } else if (item === 'NTLCLF') {
            this.inactivateUserNTLCLF();
          }
        }

      } else {
        console.log('user clicked no');
        // enable all buttons
        this.disableSubmitButton = false;
        this.disableInactivateButton = false;
      }
    });

  }

  // inactivate api calls for each facility selected
  inactivateUserEDH() {
    console.log(this.employeeInformation);
    const accessLevelTemplateValue = this.accessLevelTemplateControl.value;
    const body = {
      'active': false
    };

    const updateUserSkey = this.userInfoEDH[0].userSkey;
    console.log(updateUserSkey);
    console.log('information for update security template: ' + updateUserSkey, + ' ' + sessionStorage.getItem('ICCUserId').toUpperCase(), + ' ' + 'EDH');

    this.efsApiService.updateInfactUser(body, updateUserSkey, 'EDH', sessionStorage.getItem('ICCUserId').toUpperCase()).subscribe((data: any) => {
      this.showInactivateSuccessStatusEDH = 'true';
      console.log(data);

      // close any previous popups
      // this.popupDialogRef.close();
      // this.popupWarning(false, 'User Inactivated Successfully.');



    }, error => {
      this.showInactivateSuccessStatusEDH = 'false';
      this.apiErrorHandlingService.errorStatusHandler(error);
    });
  }

  inactivateUserHAR() {
    console.log(this.employeeInformation);
    const accessLevelTemplateValue = this.accessLevelTemplateControl.value;
    const body = {
      'active': false
    };
    const updateUserSkey = this.userInfoHAR[0].userSkey;
    console.log(updateUserSkey);
    console.log('information for update security template: ' + updateUserSkey, + ' ' + sessionStorage.getItem('ICCUserId').toUpperCase().toUpperCase(), + ' ' + 'EDH');

    this.efsApiService.updateInfactUser(body, updateUserSkey, 'HAR', sessionStorage.getItem('ICCUserId').toUpperCase()).subscribe((data: any) => {
      this.showInactivateSuccessStatusHAR = 'true';
      console.log(data);

      // close any previous popups
      // this.popupDialogRef.close();
      // this.popupWarning(false, 'User Inactivated Successfully.');

    }, error => {
      this.showInactivateSuccessStatusHAR = 'false';
      this.apiErrorHandlingService.errorStatusHandler(error);
    });
  }

  inactivateUserCPL() {
    console.log(this.employeeInformation);
    const accessLevelTemplateValue = this.accessLevelTemplateControl.value;
    const body = {
      'active': false
    };
    const updateUserSkey = this.userInfoCPL[0].userSkey;
    console.log(updateUserSkey);
    console.log('information for update security template: ' + updateUserSkey, + ' ' + sessionStorage.getItem('ICCUserId').toUpperCase().toUpperCase(), + ' ' + 'EDH');

    this.efsApiService.updateInfactUser(body, updateUserSkey, 'CPL', sessionStorage.getItem('ICCUserId').toUpperCase()).subscribe((data: any) => {
      this.showInactivateSuccessStatusCPL = 'true';
      console.log(data);

      // close any previous popups
      // this.popupDialogRef.close();
      // this.popupWarning(false, 'User Inactivated Successfully.');

    }, error => {
      this.showInactivateSuccessStatusCPL = 'false';
      this.apiErrorHandlingService.errorStatusHandler(error);
    });
  }

  inactivateUserKCW() {
    console.log(this.employeeInformation);
    const accessLevelTemplateValue = this.accessLevelTemplateControl.value;
    const body = {
      'active': false
    };
    const updateUserSkey = this.userInfoKCW[0].userSkey;
    console.log(updateUserSkey);
    console.log('information for update security template: ' + updateUserSkey, + ' ' + sessionStorage.getItem('ICCUserId').toUpperCase(), + ' ' + 'EDH');

    this.efsApiService.updateInfactUser(body, updateUserSkey, 'KCW', sessionStorage.getItem('ICCUserId').toUpperCase()).subscribe((data: any) => {
      this.showInactivateSuccessStatusKCW = 'true';
      console.log(data);

      // close any previous popups
      // this.popupDialogRef.close();
      // this.popupWarning(false, 'User Inactivated Successfully.');

    }, error => {
      this.showInactivateSuccessStatusKCW = 'false';
      this.apiErrorHandlingService.errorStatusHandler(error);
    });
  }

  inactivateUserEDGE() {
    console.log(this.employeeInformation);
    const accessLevelTemplateValue = this.accessLevelTemplateControl.value;
    const body = {
      'active': false
    };
    const updateUserSkey = this.userInfoEDGE[0].userSkey;
    console.log(updateUserSkey);
    console.log('information for update security template: ' + updateUserSkey, + ' ' + sessionStorage.getItem('ICCUserId').toUpperCase(), + ' ' + 'EDH');

    this.efsApiService.updateInfactUser(body, updateUserSkey, 'EDGE', sessionStorage.getItem('ICCUserId').toUpperCase()).subscribe((data: any) => {
      this.showInactivateSuccessStatusEDGE = 'true';
      console.log(data);

      // close any previous popups
      // this.popupDialogRef.close();
      // this.popupWarning(false, 'User Inactivated Successfully.');

    }, error => {
      this.showInactivateSuccessStatusEDGE = 'false';
      this.apiErrorHandlingService.errorStatusHandler(error);
    });
  }

  inactivateUserNTLEDH() {
    console.log(this.employeeInformation);
    const accessLevelTemplateValue = this.accessLevelTemplateControl.value;
    const body = {
      'active': false
    };
    const updateUserSkey = this.userInfoNTLEDH[0].userSkey;
    console.log(updateUserSkey);
    console.log('information for update security template: ' + updateUserSkey, + ' ' + sessionStorage.getItem('ICCUserId').toUpperCase(), + ' ' + 'EDH');

    this.efsApiService.updateInfactUser(body, updateUserSkey, 'NTLEDH', sessionStorage.getItem('ICCUserId').toUpperCase()).subscribe((data: any) => {
      this.showInactivateSuccessStatusNTLEDH = 'true';
      console.log(data);

      // close any previous popups
      // this.popupDialogRef.close();
      // this.popupWarning(false, 'User Inactivated Successfully.');

    }, error => {
      this.showInactivateSuccessStatusNTLEDH = 'false';
      this.apiErrorHandlingService.errorStatusHandler(error);
    });
  }

  inactivateUserNTLCLF() {
    console.log(this.employeeInformation);
    const accessLevelTemplateValue = this.accessLevelTemplateControl.value;
    const body = {
      'active': false
    };
    const updateUserSkey = this.userInfoNTLCLF[0].userSkey;
    console.log(updateUserSkey);
    console.log('information for update security template: ' + updateUserSkey, + ' ' + sessionStorage.getItem('ICCUserId').toUpperCase(), + ' ' + 'EDH');

    this.efsApiService.updateInfactUser(body, updateUserSkey, 'NTLCLF', sessionStorage.getItem('ICCUserId').toUpperCase()).subscribe((data: any) => {
      this.showInactivateSuccessStatusNTLCLF = 'true';
      console.log(data);

      // close any previous popups
      // this.popupDialogRef.close();
      // this.popupWarning(false, 'User Inactivated Successfully.');

    }, error => {
      this.showInactivateSuccessStatusNTLCLF = 'false';
      this.apiErrorHandlingService.errorStatusHandler(error);
    });
  }


  submitButton() {
    console.log('submit pressed');
    // create the body object to use and validate somewhat
    let associateId: String = this.employeeIdInputControl.value;
    let userId: String = this.iccUserNameControl.value;
    console.log(associateId + ' ' + userId);
    try {
      this.formInformation = {
        "userId": userId.toUpperCase(),
        "associateId": associateId,
        "firstName": this.firstNameControl.value,
        "lastName": this.lastNameControl.value,
        "email": this.email.value,
      };
    } catch {
      this.popupWarning(false, 'Associate Id or User Id is missing.');
      return;
    }
    // check validity of form
    const validForm = this.checkFormValidity();
    console.log('is form valid? ' + validForm);
    if (!validForm) {
      return;
    }
    this.showSubmissionStatus = true;
    this.showUpdateStatuses = true;
    this.showCreateUserStatuses = true;
    // disable all buttons
    this.disableSubmitButton = true;
    this.disableInactivateButton = true;
    // disable all fields
    this.firstNameControl.disable();
    this.lastNameControl.disable();
    this.employeeIdInputControl.disable();
    this.iccUserNameControl.disable();
    this.email.disable();
    this.accessLevelTemplateControl.disable();
    this.multiselect.disable();


    // if (this.creatingNewUser) {
    // new user uses a different api, must call for each facility selected for
    // apply the security template to the user for the selected facilities
    console.log(this.multiselect.value);
    let userSelectedFacilities = [];
    try {
      if (this.multiselect.value.length > 0) {
        for (const item of this.multiselect.value) {
          userSelectedFacilities.push(item);
        }
      }
    } catch {
      console.log('no facilities selected');
      return;
    }

    // run a simple update if user has already existed on a facility. 
    // run a create user if user selected a facility in which they had not previously existed
    let createUserInFacility = [];
    // check for new facilities first by first checking newly selected facilities against the known user facilities
    createUserInFacility = userSelectedFacilities.filter(x => !this.employeeFacilityLocation.includes(x));
    // create a list of facilities where the user already exists in, but has been selected. this is for simple update and no create user
    let updateUserInFacility = [];
    updateUserInFacility = userSelectedFacilities.filter(x => this.employeeFacilityLocation.includes(x));

    console.log(JSON.stringify(createUserInFacility));
    console.log(JSON.stringify(updateUserInFacility));
    console.log(JSON.stringify(this.employeeFacilityLocation));
    console.log(JSON.stringify(userSelectedFacilities));

    this.popupWarning(false, 'Please Check The submission panel for Status');

    console.log(JSON.stringify(this.formInformation));
    console.log(JSON.stringify(this.accessLevelTemplateControl.value));

    // use createUserInfacility list to do addnewUser funcs
    // console.log(JSON.stringify(createUserInFacility));
    for (const item of createUserInFacility) {
      console.log(JSON.stringify(item));
      if (item === 'EDH') {
        this.addNewUserToFacilityEDH();
      } else if (item === 'HAR') {
        this.addNewUserToFacilityHAR();
      } else if (item === 'KCW') {
        this.addNewUserToFacilityKCW();
      } else if (item === 'CPL') {
        this.addNewUserToFacilityCPL();
      } else if (item === 'EDG') {
        this.addNewUserToFacilityEDGE();
      } else if (item === 'NTLEDH') {
        this.addNewUserToFacilityNTLEDH();
      } else if (item === 'NTLCLF') {
        this.addNewUserToFacilityNTLCLF();
      }
    }

    // use employee facilityLocation to do updateTemplate funcs
    // apply the security template to the user for the selected facilities
    console.log(JSON.stringify(updateUserInFacility));
    for (const item of updateUserInFacility) {
      console.log(JSON.stringify(item));
      if (item === 'EDH') {
        this.applySecurityTemplateEDH();
      } else if (item === 'HAR') {
        this.applySecurityTemplateHAR();
      } else if (item === 'KCW') {
        this.applySecurityTemplateKCW();
      } else if (item === 'CPL') {
        this.applySecurityTemplateCPL();
      } else if (item === 'EDG') {
        this.applySecurityTemplateEDGE();
      } else if (item === 'NTLEDH') {
        this.applySecurityTemplateNTLEDH();
      } else if (item === 'NTLCLF') {
        this.applySecurityTemplateNTLCLF();
      }
    }
  }

  // api calls for adding a new user to a facility
  addNewUserToFacilityEDH() {
    console.log(this.employeeInformation);
    const accessLevelTemplateValue = this.accessLevelTemplateControl.value;
    // create user body from input info
    const body = this.formInformation;
    console.log(JSON.stringify(body));

    this.efsApiService.createInfactUser(body, 'EDH', sessionStorage.getItem('ICCUserId').toUpperCase()).subscribe((data: any) => {
      this.showSuccessStatusEDH = 'true';
      console.log(data);
      this.employeeInformation = data;
      this.userInfoEDH = data;
      // with the skey now available, we can call the sibling function to add this user to selected security template
      setTimeout(() => {
        this.applySecurityTemplateEDH();
      }, 1000);


    }, error => {
      this.showSuccessStatusEDH = 'false';
      // this.apiErrorHandlingService.errorStatusHandler(error);
      console.error(error);
    });
  }

  addNewUserToFacilityHAR() {
    console.log(this.employeeInformation);
    const accessLevelTemplateValue = this.accessLevelTemplateControl.value;
    // create user body from input info
    const body = this.formInformation;
    console.log(JSON.stringify(body));

    this.efsApiService.createInfactUser(body, 'HAR', sessionStorage.getItem('ICCUserId').toUpperCase()).subscribe((data: any) => {
      this.showSuccessStatusHAR = 'true';
      console.log(data);
      this.employeeInformation = data;
      this.userInfoHAR = data;
      // with the skey now available, we can call the sibling function to add this user to selected security template
      this.applySecurityTemplateHAR();

    }, error => {
      this.showSuccessStatusHAR = 'false';
      // this.apiErrorHandlingService.errorStatusHandler(error);
      console.error(error);
    });
  }

  addNewUserToFacilityKCW() {
    console.log(this.employeeInformation);
    const accessLevelTemplateValue = this.accessLevelTemplateControl.value;
    // create user body from input info
    const body = this.formInformation;
    console.log(JSON.stringify(body));

    this.efsApiService.createInfactUser(body, 'KCW', sessionStorage.getItem('ICCUserId').toUpperCase()).subscribe((data: any) => {
      this.showSuccessStatusKCW = 'true';
      console.log(data);
      this.employeeInformation = data;
      this.userInfoKCW = data;
      // with the skey now available, we can call the sibling function to add this user to selected security template
      this.applySecurityTemplateKCW();

    }, error => {
      this.showSuccessStatusKCW = 'false';
      // this.apiErrorHandlingService.errorStatusHandler(error);
      console.error(error);
    });
  }

  addNewUserToFacilityCPL() {
    console.log(this.employeeInformation);
    const accessLevelTemplateValue = this.accessLevelTemplateControl.value;
    // create user body from input info
    const body = this.formInformation;
    console.log(JSON.stringify(body));

    this.efsApiService.createInfactUser(body, 'CPL', sessionStorage.getItem('ICCUserId').toUpperCase()).subscribe((data: any) => {
      this.showSuccessStatusCPL = 'true';
      console.log(data);
      this.employeeInformation = data;
      this.userInfoCPL = data;
      // with the skey now available, we can call the sibling function to add this user to selected security template
      this.applySecurityTemplateCPL();

    }, error => {
      this.showSuccessStatusCPL = 'false';
      // this.apiErrorHandlingService.errorStatusHandler(error);
      console.error(error);
    });
  }

  addNewUserToFacilityEDGE() {
    console.log(this.employeeInformation);
    const accessLevelTemplateValue = this.accessLevelTemplateControl.value;
    // create user body from input info
    const body = this.formInformation;
    console.log(JSON.stringify(body));

    this.efsApiService.createInfactUser(body, 'EDGE', sessionStorage.getItem('ICCUserId').toUpperCase()).subscribe((data: any) => {
      this.showSuccessStatusEDGE = 'true';
      console.log(data);
      this.employeeInformation = data;
      this.userInfoEDGE = data;
      // with the skey now available, we can call the sibling function to add this user to selected security template
      this.applySecurityTemplateEDGE();

    }, error => {
      this.showSuccessStatusEDGE = 'false';
      // this.apiErrorHandlingService.errorStatusHandler(error);
      console.error(error);
    });
  }

  addNewUserToFacilityNTLEDH() {
    console.log(this.employeeInformation);
    const accessLevelTemplateValue = this.accessLevelTemplateControl.value;
    // create user body from input info
    const body = this.formInformation;
    console.log(JSON.stringify(body));

    this.efsApiService.createInfactUser(body, 'NTLEDH', sessionStorage.getItem('ICCUserId').toUpperCase()).subscribe((data: any) => {
      this.showSuccessStatusNTLEDH = 'true';
      console.log(data);
      this.employeeInformation = data;
      this.userInfoNTLEDH = data;
      // with the skey now available, we can call the sibling function to add this user to selected security template
      this.applySecurityTemplateNTLEDH();

    }, error => {
      this.showSuccessStatusNTLEDH = 'false';
      // this.apiErrorHandlingService.errorStatusHandler(error);
      console.error(error);
    });
  }

  addNewUserToFacilityNTLCLF() {
    console.log(this.employeeInformation);
    const accessLevelTemplateValue = this.accessLevelTemplateControl.value;
    // create user body from input info
    const body = this.formInformation;
    console.log(JSON.stringify(body));

    this.efsApiService.createInfactUser(body, 'NTLCLF', sessionStorage.getItem('ICCUserId').toUpperCase()).subscribe((data: any) => {
      this.showSuccessStatusNTLCLF = 'true';
      console.log(data);
      this.employeeInformation = data;
      this.userInfoNTLCLF = data;
      // with the skey now available, we can call the sibling function to add this user to selected security template
      this.applySecurityTemplateNTLCLF();

    }, error => {
      this.showSuccessStatusNTLCLF = 'false';
      // this.apiErrorHandlingService.errorStatusHandler(error);
      console.error(error);
    });
  }

  // API calls for setting security template to a user and facility
  applySecurityTemplateEDH() {
    console.log(this.employeeInformation);
    const accessLevelTemplateValue = this.accessLevelTemplateControl.value;
    console.log('information for update security template: ' + this.employeeInformation.userSkey, + ' ' + accessLevelTemplateValue.securityTemplateId, + ' ' + 'EDH');
    let updateUserSkey = '';
    try {
      updateUserSkey = this.userInfoEDH[0].userSkey;
    } catch {
      console.log('skey is not in a list, but in a json');
      try {
        updateUserSkey = this.userInfoEDH.userSkey;
      } catch {
        this.showUpdateSuccessStatusEDH = 'false';
      }
      this.showUpdateSuccessStatusEDH = 'false';
    }

    console.log(updateUserSkey);
    // get template id based on matching name from the list
    let accessLevelTemplateValueId = '';
    for (const item of this.securityTemplateEDH) {
      if (item.securityTemplateName === accessLevelTemplateValue) {
        accessLevelTemplateValueId = item.securityTemplateId;
      }
    }
    if (accessLevelTemplateValueId === '') {
      console.log('access level template id was not set correctly');
      this.showUpdateSuccessStatusEDH = 'false';
      return;
    }
    console.log(accessLevelTemplateValueId);

    this.efsApiService.updateUserSecurityTemplate(updateUserSkey, accessLevelTemplateValueId, 'EDH', sessionStorage.getItem('ICCUserId').toUpperCase()).subscribe((data: any) => {
      this.showUpdateSuccessStatusEDH = 'true';
      console.log(data);

      // close any previous popups
      // this.popupDialogRef.close();
      // this.popupWarning(false, 'Successfully Added');


    }, error => {
      this.showUpdateSuccessStatusEDH = 'false';
      // this.apiErrorHandlingService.errorStatusHandler(error);
      console.error(error);
    });
  }

  applySecurityTemplateHAR() {
    console.log(this.employeeInformation);
    const accessLevelTemplateValue = this.accessLevelTemplateControl.value;
    console.log('information for update security template: ' + this.employeeInformation.userSkey, + ' ' + accessLevelTemplateValue.securityTemplateId, + ' ' + 'HAR');
    let updateUserSkey = '';
    try {
      updateUserSkey = this.userInfoHAR[0].userSkey;
    } catch {
      console.log('skey is not in a list, but in a json');
      try {
        updateUserSkey = this.userInfoHAR.userSkey;
      } catch {
        this.showUpdateSuccessStatusHAR = 'false';
      }
      this.showUpdateSuccessStatusHAR = 'false';
    }
    console.log(updateUserSkey);
    // get template id based on matching name from the list
    let accessLevelTemplateValueId = '';
    for (const item of this.securityTemplateHAR) {
      if (item.securityTemplateName === accessLevelTemplateValue) {
        accessLevelTemplateValueId = item.securityTemplateId;
      }
    }
    if (accessLevelTemplateValueId === '') {
      console.log('access level template id was not set correctly');
      this.showUpdateSuccessStatusHAR = 'false';
      return;
    }
    console.log(accessLevelTemplateValueId);

    this.efsApiService.updateUserSecurityTemplate(updateUserSkey, accessLevelTemplateValueId, 'HAR', sessionStorage.getItem('ICCUserId').toUpperCase()).subscribe((data: any) => {
      this.showUpdateSuccessStatusHAR = 'true';
      console.log(data);

      // close any previous popups
      // this.popupDialogRef.close();
      // this.popupWarning(false, 'Successfully Added');

    }, error => {
      this.showUpdateSuccessStatusHAR = 'false';
      // this.apiErrorHandlingService.errorStatusHandler(error);
      console.error(error);
    });
  }

  applySecurityTemplateKCW() {
    console.log(this.employeeInformation);
    const accessLevelTemplateValue = this.accessLevelTemplateControl.value;
    console.log('information for update security template: ' + this.employeeInformation.userSkey, + ' ' + accessLevelTemplateValue.securityTemplateId, + ' ' + 'KCW');
    let updateUserSkey = '';
    try {
      updateUserSkey = this.userInfoKCW[0].userSkey;
    } catch {
      console.log('skey is not in a list, but in a json');
      try {
        updateUserSkey = this.userInfoKCW.userSkey;
      } catch {
        this.showUpdateSuccessStatusKCW = 'false';
      }
      this.showUpdateSuccessStatusKCW = 'false';
    }
    console.log(updateUserSkey);
    // get template id based on matching name from the list
    let accessLevelTemplateValueId = '';
    for (const item of this.securityTemplateKCW) {
      if (item.securityTemplateName === accessLevelTemplateValue) {
        accessLevelTemplateValueId = item.securityTemplateId;
      }
    }
    if (accessLevelTemplateValueId === '') {
      console.log('access level template id was not set correctly');
      this.showUpdateSuccessStatusKCW = 'false';
      return;
    }
    console.log(accessLevelTemplateValueId);

    this.efsApiService.updateUserSecurityTemplate(updateUserSkey, accessLevelTemplateValueId, 'KCW', sessionStorage.getItem('ICCUserId').toUpperCase()).subscribe((data: any) => {
      this.showUpdateSuccessStatusKCW = 'true';
      console.log(data);

      // close any previous popups
      // this.popupDialogRef.close();
      // this.popupWarning(false, 'Successfully Added');

    }, error => {
      this.showUpdateSuccessStatusKCW = 'false';
      // this.apiErrorHandlingService.errorStatusHandler(error);
      console.error(error);
    });
  }

  applySecurityTemplateCPL() {
    console.log(this.employeeInformation);
    const accessLevelTemplateValue = this.accessLevelTemplateControl.value;
    console.log('information for update security template: ' + this.employeeInformation.userSkey, + ' ' + accessLevelTemplateValue.securityTemplateId, + ' ' + 'CPL');
    let updateUserSkey = '';
    try {
      updateUserSkey = this.userInfoCPL[0].userSkey;
    } catch {
      console.log('skey is not in a list, but in a json');
      try {
        updateUserSkey = this.userInfoCPL.userSkey;
      } catch {
        this.showUpdateSuccessStatusCPL = 'false';
      }
      this.showUpdateSuccessStatusCPL = 'false';
    }
    console.log(updateUserSkey);
    // get template id based on matching name from the list
    let accessLevelTemplateValueId = '';
    for (const item of this.securityTemplateCPL) {
      if (item.securityTemplateName === accessLevelTemplateValue) {
        accessLevelTemplateValueId = item.securityTemplateId;
      }
    }
    if (accessLevelTemplateValueId === '') {
      console.log('access level template id was not set correctly');
      this.showUpdateSuccessStatusCPL = 'false';
      return;
    }
    console.log(accessLevelTemplateValueId);

    this.efsApiService.updateUserSecurityTemplate(updateUserSkey, accessLevelTemplateValueId, 'CPL', sessionStorage.getItem('ICCUserId').toUpperCase()).subscribe((data: any) => {
      this.showUpdateSuccessStatusCPL = 'true';
      console.log(data);

      // close any previous popups
      // this.popupDialogRef.close();
      // this.popupWarning(false, 'Successfully Added');

    }, error => {
      this.showUpdateSuccessStatusCPL = 'false';
      // this.apiErrorHandlingService.errorStatusHandler(error);
      console.error(error);
    });
  }

  applySecurityTemplateEDGE() {
    console.log(this.employeeInformation);
    const accessLevelTemplateValue = this.accessLevelTemplateControl.value;
    console.log('information for update security template: ' + this.employeeInformation.userSkey, + ' ' + accessLevelTemplateValue.securityTemplateId, + ' ' + 'EDGE');
    let updateUserSkey = '';
    try {
      updateUserSkey = this.userInfoEDGE[0].userSkey;
    } catch {
      console.log('skey is not in a list, but in a json');
      try {
        updateUserSkey = this.userInfoEDGE.userSkey;
      } catch {
        this.showUpdateSuccessStatusEDGE = 'false';
      }
      this.showUpdateSuccessStatusEDGE = 'false';
    }
    console.log(updateUserSkey);
    // get template id based on matching name from the list
    let accessLevelTemplateValueId = '';
    for (const item of this.securityTemplateEDGE) {
      if (item.securityTemplateName === accessLevelTemplateValue) {
        accessLevelTemplateValueId = item.securityTemplateId;
      }
    }
    if (accessLevelTemplateValueId === '') {
      console.log('access level template id was not set correctly');
      this.showUpdateSuccessStatusEDGE = 'false';
      return;
    }
    console.log(accessLevelTemplateValueId);

    this.efsApiService.updateUserSecurityTemplate(updateUserSkey, accessLevelTemplateValueId, 'EDGE', sessionStorage.getItem('ICCUserId').toUpperCase()).subscribe((data: any) => {
      this.showUpdateSuccessStatusEDGE = 'true';
      console.log(data);

      // close any previous popups
      // this.popupDialogRef.close();
      // this.popupWarning(false, 'Successfully Added');

    }, error => {
      this.showUpdateSuccessStatusEDGE = 'false';
      // this.apiErrorHandlingService.errorStatusHandler(error);
      console.error(error);
    });
  }

  applySecurityTemplateNTLEDH() {
    console.log(this.employeeInformation);
    const accessLevelTemplateValue = this.accessLevelTemplateControl.value;
    console.log('information for update security template: ' + this.employeeInformation.userSkey, + ' ' + accessLevelTemplateValue.securityTemplateId, + ' ' + 'NTLEDH');
    let updateUserSkey = '';
    try {
      updateUserSkey = this.userInfoNTLEDH[0].userSkey;
    } catch {
      console.log('skey is not in a list, but in a json');
      try {
        updateUserSkey = this.userInfoNTLEDH.userSkey;
      } catch {
        this.showUpdateSuccessStatusNTLEDH = 'false';
      }
      this.showUpdateSuccessStatusNTLEDH = 'false';
    }
    console.log(updateUserSkey);
    // get template id based on matching name from the list
    let accessLevelTemplateValueId = '';
    for (const item of this.securityTemplateNTLEDH) {
      if (item.securityTemplateName === accessLevelTemplateValue) {
        accessLevelTemplateValueId = item.securityTemplateId;
      }
    }
    if (accessLevelTemplateValueId === '') {
      console.log('access level template id was not set correctly');
      this.showUpdateSuccessStatusNTLEDH = 'false';
      return;
    }
    console.log(accessLevelTemplateValueId);

    this.efsApiService.updateUserSecurityTemplate(updateUserSkey, accessLevelTemplateValueId, 'NTLEDH', sessionStorage.getItem('ICCUserId').toUpperCase()).subscribe((data: any) => {
      this.showUpdateSuccessStatusNTLEDH = 'true';
      console.log(data);

      // close any previous popups
      // this.popupDialogRef.close();
      // this.popupWarning(false, 'Successfully Added');

    }, error => {
      this.showUpdateSuccessStatusNTLEDH = 'false';
      // this.apiErrorHandlingService.errorStatusHandler(error);
      console.error(error);
    });
  }

  applySecurityTemplateNTLCLF() {
    console.log(this.employeeInformation);
    const accessLevelTemplateValue = this.accessLevelTemplateControl.value;
    console.log('information for update security template: ' + this.employeeInformation.userSkey, + ' ' + accessLevelTemplateValue.securityTemplateId, + ' ' + 'NTLCLF');
    let updateUserSkey = '';
    try {
      updateUserSkey = this.userInfoNTLCLF[0].userSkey;
    } catch {
      console.log('skey is not in a list, but in a json');
      try {
        updateUserSkey = this.userInfoNTLCLF.userSkey;
      } catch {
        this.showUpdateSuccessStatusNTLCLF = 'false';
      }
      this.showUpdateSuccessStatusNTLCLF = 'false';
    }
    console.log(updateUserSkey);
    // get template id based on matching name from the list
    let accessLevelTemplateValueId = '';
    for (const item of this.securityTemplateNTLCLF) {
      if (item.securityTemplateName === accessLevelTemplateValue) {
        accessLevelTemplateValueId = item.securityTemplateId;
      }
    }
    if (accessLevelTemplateValueId === '') {
      console.log('access level template id was not set correctly');
      this.showUpdateSuccessStatusNTLCLF = 'false';
      return;
    }
    console.log(accessLevelTemplateValueId);

    this.efsApiService.updateUserSecurityTemplate(updateUserSkey, accessLevelTemplateValueId, 'NTLCLF', sessionStorage.getItem('ICCUserId').toUpperCase()).subscribe((data: any) => {
      this.showUpdateSuccessStatusNTLCLF = 'true';
      console.log(data);

      // close any previous popups
      // this.popupDialogRef.close();
      // this.popupWarning(false, 'Successfully Added');

    }, error => {
      this.showUpdateSuccessStatusNTLCLF = 'false';
      // this.apiErrorHandlingService.errorStatusHandler(error);
      console.error(error);
    });
  }

  cancelButton() {
    console.log('cancel pressed');
    this.showUserResults = false;
    this.newUserEntry = false;
    this.disableSubmitButton = true;
    this.disableInactivateButton = false;
    this.clearFields();
    this.resetSubmissionStatuses();
  }

  // set the cross section of available security templates depending on which facilities have been selected.
  setSecurityTemplateDropdown() {
    this.accessLevelTemplateControl.reset();
    this.accessLevelTemplateControl.disable();
    this.securityTemplateFiltered = [];
    this.finalSecurityTemplatesFiltered = [];
    this.finalFinalSecurityTemplatesFiltered = [];

    // get the number of selected facilities
    const selectedFacilitiesNumber = this.multiselect.value.length;
    console.log(selectedFacilitiesNumber);
    // merge all selected facilities into a single array and count the appearance (duplicates) with same securityTemplateName
    // if the duplicates reach the same number as selectedfacilities number, it should go into the final list.
    for (const item of this.multiselect.value) {
      // console.log(JSON.stringify(item));
      if (item === 'EDH') {
        this.securityTemplateFiltered = this.securityTemplateFiltered.concat(this.securityTemplateEDH);
      } else if (item === 'HAR') {
        this.securityTemplateFiltered = this.securityTemplateFiltered.concat(this.securityTemplateHAR);
      } else if (item === 'KCW') {
        this.securityTemplateFiltered = this.securityTemplateFiltered.concat(this.securityTemplateKCW);
      } else if (item === 'CPL') {
        this.securityTemplateFiltered = this.securityTemplateFiltered.concat(this.securityTemplateCPL);
      } else if (item === 'EDG') {
        this.securityTemplateFiltered = this.securityTemplateFiltered.concat(this.securityTemplateEDGE);
      } else if (item === 'NTLEDH') {
        this.securityTemplateFiltered = this.securityTemplateFiltered.concat(this.securityTemplateNTLEDH);
      } else if (item === 'NTLCLF') {
        this.securityTemplateFiltered = this.securityTemplateFiltered.concat(this.securityTemplateNTLCLF);
      }
    }
    console.log(JSON.stringify(this.securityTemplateFiltered));
    // instead of getting rid of duplicates, count the duplicates and keep those
    for (const dupeCheck of this.securityTemplateFiltered) {
      // loop to check for requisite duplicates to add to the final list
      let dupeCount = 0;
      for (const item of this.securityTemplateFiltered) {
        // console.log(dupeCheck.securityTemplateName + ' ' + item.securityTemplateName);
        if (dupeCheck.securityTemplateName === item.securityTemplateName) {
          dupeCount++;
        }
      }
      if (dupeCount === selectedFacilitiesNumber) {
        this.finalSecurityTemplatesFiltered.push(dupeCheck.securityTemplateName);
      }
    }
    // the below loop deletes duplicates
    this.finalFinalSecurityTemplatesFiltered = [...new Set(this.finalSecurityTemplatesFiltered)];
    this.finalFinalSecurityTemplatesFiltered.sort();
    // const noDupeMax = 1;
    // for (const dupeCheck of this.finalSecurityTemplatesFiltered) {
    //   // loop to check for requisite duplicates to add to the final list
    //   let dupeCount = 0;
    //   for (const item of this.finalSecurityTemplatesFiltered) {
    //     // console.log(dupeCheck.securityTemplateName + ' ' + item.securityTemplateName);
    //     if (dupeCheck.securityTemplateName === item.securityTemplateName) {
    //       dupeCount++;
    //     }
    //   }
    //   if (dupeCount === noDupeMax) {
    //     this.finalFinalSecurityTemplatesFiltered.push(dupeCheck)
    //   }
    // }
    console.log(JSON.stringify(this.finalFinalSecurityTemplatesFiltered));
    this.accessLevelTemplateControl.enable();
  }

  resetSubmissionStatuses() {
    this.showSubmissionStatus = false;
    this.showInactivateUserStatuses = false;
    this.showCreateUserStatuses = false;
    this.showUpdateStatuses = false;

    this.disableSubmitButton = true;

    this.showSuccessStatusEDH = '';
    this.showSuccessStatusHAR = '';
    this.showSuccessStatusKCW = '';
    this.showSuccessStatusCPL = '';
    this.showSuccessStatusEDGE = '';
    this.showSuccessStatusNTLEDH = '';
    this.showSuccessStatusNTLCLF = '';

    this.showUpdateSuccessStatusEDH = '';
    this.showUpdateSuccessStatusHAR = '';
    this.showUpdateSuccessStatusKCW = '';
    this.showUpdateSuccessStatusCPL = '';
    this.showUpdateSuccessStatusEDGE = '';
    this.showUpdateSuccessStatusNTLEDH = '';
    this.showUpdateSuccessStatusNTLCLF = '';

    this.showInactivateSuccessStatusEDH = '';
    this.showInactivateSuccessStatusHAR = '';
    this.showInactivateSuccessStatusKCW = '';
    this.showInactivateSuccessStatusCPL = '';
    this.showInactivateSuccessStatusEDGE = '';
    this.showInactivateSuccessStatusNTLEDH = '';
    this.showInactivateSuccessStatusNTLCLF = '';

    this.securityTemplateFiltered = [];
    this.finalSecurityTemplatesFiltered = [];
    this.finalFinalSecurityTemplatesFiltered = [];
  }

  verifyInfactUserButton() {
    console.log('verifyInfactUser button pressed');

    this.verifyInfactUserButtonDisable = true;
    this.getLfsUserByInfactUserId(sessionStorage.getItem('employeeId'));
  }

  clearFields(search?) {
    // clear the fields
    this.firstNameControl.reset();
    this.lastNameControl.reset();
    this.iccUserNameControl.reset();
    this.email.reset();
    if (search) {
      // do nothing
    } else {
      this.employeeIdControl.reset();
    }
    this.employeeIdInputControl.reset();
    // clear the role product and access level, variables
    // this.facilityControl.reset();
    this.multiselect.reset();
    this.accessLevelTemplateControl.reset();
    // this.roleAccessDescription = null;
    // this.accessLevelDesc = null;
    // this.ccUserNm = null;
    // this.radioControl.reset();
    this.form.reset();
    this.employeeFacilityLocation = [];
    this.employeeInformation = null;
    this.employeeFacilityLocation = [];
    this.userInfoAny = {};
    // this.adminCheckbox.reset();
    // disable checkboxes and radios
    // this.radioControl.disable();
    // this.form.disable();
  }

  popupWarning(questionType, message, useSpinner?) {
    this.popupDialogRef = this.dialog.open(GenericPopupComponent, {
      width: '450px',
      height: '250px',
      panelClass: 'popup-borders',
      data: {
        questionType,
        title: 'Alert',
        message,
        useSpinner
      }
    });
    // return true;
  }

  // listen for input to form, check status of form and disable or enable submit button
  checkFormStatus() {
    this.firstNameControl.valueChanges.subscribe(input => {
      if (this.checkFormValidity()) {
        this.disableSubmitButton = false;
      } else {
        this.disableSubmitButton = true;
      }
    });
    this.lastNameControl.valueChanges.subscribe(input => {
      if (this.checkFormValidity()) {
        this.disableSubmitButton = false;
      } else {
        this.disableSubmitButton = true;
      }
    });
    this.email.valueChanges.subscribe(input => {
      if (this.checkFormValidity()) {
        this.disableSubmitButton = false;
      } else {
        this.disableSubmitButton = true;
      }
    });
    this.iccUserNameControl.valueChanges.subscribe(input => {
      if (this.checkFormValidity()) {
        this.disableSubmitButton = false;
      } else {
        this.disableSubmitButton = true;
      }
    });
    this.employeeIdInputControl.valueChanges.subscribe(input => {
      if (this.checkFormValidity()) {
        this.disableSubmitButton = false;
      } else {
        this.disableSubmitButton = true;
      }
    });
    this.multiselect.valueChanges.subscribe(input => {
      // check for invactivate button only
      if (!this.multiselect.valid) {
        this.disableInactivateButton = true;
      } else {
        this.disableInactivateButton = false;
      }
      // regular check
      if (this.checkFormValidity()) {
        this.disableSubmitButton = false;
      } else {
        this.disableSubmitButton = true;
      }
    });
    this.accessLevelTemplateControl.valueChanges.subscribe(input => {
      if (this.checkFormValidity()) {
        this.disableSubmitButton = false;
      } else {
        this.disableSubmitButton = true;
      }
    });

  }

  // check inputs from the form, if any are incorrect or missing return false
  checkFormValidity() {
    if (!this.multiselect.valid) {
      return false;
    } else if (!this.accessLevelTemplateControl.valid) {
      return false;
    }
    if (!this.firstNameControl.valid) {
      console.log(this.firstNameControl.status);
      if (this.firstNameControl.status === 'DISABLED') {
        return true;
      } else {
        return false;
      }
    } else if (!this.lastNameControl.valid) {
      console.log(this.lastNameControl.status);
      if (this.lastNameControl.status === 'DISABLED') {
        return true;
      } else {
        return false;
      }
    } else if (!this.email.valid) {
      console.log(this.email.status);
      if (this.email.status === 'DISABLED') {
        return true;
      } else {
        return false;
      }
    } else if (!this.iccUserNameControl.valid) {
      console.log(this.iccUserNameControl.status);
      if (this.iccUserNameControl.status === 'DISABLED') {
        return true;
      } else {
        return false;
      }
    } else if (!this.employeeIdInputControl.valid) {
      console.log(this.employeeIdInputControl.status);
      console.log(this.creatingNewUser);
      if (this.creatingNewUser) {
        if (this.employeeIdInputControl.status === 'DISABLED') {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    } else {
      return true;
    }
  }
}

export interface SelectOption {
  value: string;
  viewValue: string;
}
